import {filter, fromEvent, map, Observable} from 'rxjs';

import {globalWindow} from '../../helpers/browser/browserHelpers';
import {KeyValueStore} from './storageCommon';

/*
 * Api.
 */

export const keyValueStore: KeyValueStore = {
  read: readLocalStorage,
  observe: observeLocalStorage,
  set: setLocalStorage,
  clear: clearStorage,
};

/*
 * Helpers.
 */

function readLocalStorage(key: string) {
  try {
    const value = localStorage.getItem(key);
    if (!value) {
      return undefined;
    }

    return value;
  } catch (error) {
    return undefined;
  }
}

function observeLocalStorage(key: string): Observable<string | undefined> {
  return fromEvent<StorageEvent>(globalWindow, 'storage').pipe(
    filter((event) => event.key === key),
    map((event) => event.newValue ?? undefined),
  );
}

function setLocalStorage(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // Ignore.
  }
}

function clearStorage(): void {
  // TODO: Have better mechanism to detect if storage is ours.
  localStorage.clear();
}
